'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Image from 'next/image';

const navLinks = [
  { label: 'Courses', href: '#courses' },
  { label: 'How It Works', href: '#process' },
  { label: 'Results', href: '#results' },
  { label: 'Location', href: '#location' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <>
      <header data-component-id="src/components/Header.tsx:38:6" data-component-path="src/components/Header.tsx" data-component-line="38" data-component-end-line="103" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-white/95 backdrop-blur-xl shadow-soft border-b border-border'
            : 'bg-transparent'
        }`}
      >
        <div data-component-id="src/components/Header.tsx:45:8" data-component-path="src/components/Header.tsx" data-component-line="45" data-component-end-line="102" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-12%20h-20%20flex%20items-center%20justify-between%22%7D" className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
          {/* Logo */}
          <Link data-component-id="src/components/Header.tsx:47:10" data-component-path="src/components/Header.tsx" data-component-line="47" data-component-end-line="55" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20group%22%7D" href="/" className="flex items-center gap-3 group">
            <Image data-component-id="src/components/Header.tsx:48:12" data-component-path="src/components/Header.tsx" data-component-line="48" data-component-end-line="54" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fassets%2Fimages%2Fshiksham-logo.png%22%2C%22alt%22%3A%22Shiksham%20Academy%20Logo%22%2C%22className%22%3A%22object-contain%22%7D"
  src="/assets/images/shiksham-logo.png"
  alt="Shiksham Academy Logo"
  width={140}
  height={40}
  className="object-contain"
/>
          </Link>

          {/* Desktop Nav */}
          <nav data-component-id="src/components/Header.tsx:58:10" data-component-path="src/components/Header.tsx" data-component-line="58" data-component-end-line="68" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20gap-8%22%7D" className="hidden lg:flex items-center gap-8">
            {navLinks?.map((link) => (
              <a data-component-id="src/components/Header.tsx:60:14" data-component-path="src/components/Header.tsx" data-component-line="60" data-component-end-line="66" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22text-%5B11px%5D%20font-bold%20uppercase%20tracking-widest%20text-muted%20hover%3Atext-primary%20transition-colors%20link-underline%22%7D"
                key={link?.label}
                href={link?.href}
                className="text-[11px] font-bold uppercase tracking-widest text-muted hover:text-primary transition-colors link-underline"
              >
                {link?.label}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div data-component-id="src/components/Header.tsx:71:10" data-component-path="src/components/Header.tsx" data-component-line="71" data-component-end-line="78" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20gap-4%22%7D" className="hidden lg:flex items-center gap-4">
            <a data-component-id="src/components/Header.tsx:72:12" data-component-path="src/components/Header.tsx" data-component-line="72" data-component-end-line="77" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22tel%3A%2B916363611772%22%2C%22className%22%3A%22btn-primary%20text-xs%20py-3%20px-6%22%2C%22textContent%22%3A%22%F0%9F%93%9E%20Book%20Free%20Demo%22%7D"
              href="tel:+916363611772"
              className="btn-primary text-xs py-3 px-6"
            >
              📞 Book Free Demo
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button data-component-id="src/components/Header.tsx:81:10" data-component-path="src/components/Header.tsx" data-component-line="81" data-component-end-line="101" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20flex%20flex-col%20gap-1.5%20p-2%20z-50%20relative%22%7D"
            className="lg:hidden flex flex-col gap-1.5 p-2 z-50 relative"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <span data-component-id="src/components/Header.tsx:86:12" data-component-path="src/components/Header.tsx" data-component-line="86" data-component-end-line="90" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block w-6 h-0.5 bg-primary transition-all duration-300 ${
                menuOpen ? 'rotate-45 translate-y-2' : ''
              }`}
            />
            <span data-component-id="src/components/Header.tsx:91:12" data-component-path="src/components/Header.tsx" data-component-line="91" data-component-end-line="95" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block w-6 h-0.5 bg-primary transition-all duration-300 ${
                menuOpen ? 'opacity-0' : ''
              }`}
            />
            <span data-component-id="src/components/Header.tsx:96:12" data-component-path="src/components/Header.tsx" data-component-line="96" data-component-end-line="100" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block w-6 h-0.5 bg-primary transition-all duration-300 ${
                menuOpen ? '-rotate-45 -translate-y-2' : ''
              }`}
            />
          </button>
        </div>
      </header>
      {/* Mobile Menu Overlay */}
      <div data-component-id="src/components/Header.tsx:105:6" data-component-path="src/components/Header.tsx" data-component-line="105" data-component-end-line="127" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`fixed inset-0 z-40 bg-white/98 backdrop-blur-xl transition-all duration-500 flex flex-col items-center justify-center gap-8 ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        {navLinks?.map((link) => (
          <a data-component-id="src/components/Header.tsx:111:10" data-component-path="src/components/Header.tsx" data-component-line="111" data-component-end-line="118" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22text-2xl%20font-black%20uppercase%20tracking-widest%20text-primary%20hover%3Atext-accent%20transition-colors%22%7D"
            key={link?.label}
            href={link?.href}
            onClick={handleNavClick}
            className="text-2xl font-black uppercase tracking-widest text-primary hover:text-accent transition-colors"
          >
            {link?.label}
          </a>
        ))}
        <a data-component-id="src/components/Header.tsx:120:8" data-component-path="src/components/Header.tsx" data-component-line="120" data-component-end-line="126" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22tel%3A%2B916363611772%22%2C%22className%22%3A%22btn-primary%20mt-4%22%2C%22textContent%22%3A%22%F0%9F%93%9E%20Book%20Free%20Demo%22%7D"
          href="tel:+916363611772"
          onClick={handleNavClick}
          className="btn-primary mt-4"
        >
          📞 Book Free Demo
        </a>
      </div>
    </>
  );
}